import dayjs from "dayjs";

/**
 * Map meeting schedule GET detail fields to WhatsApp send payload identifiers.
 * Adjust keys if API uses different names.
 */

export function formatScheduleSlotTime(value) {
  if (value === undefined || value === null || value === "") {
    return "";
  }
  return dayjs(value, ["HH:mm:ss", "HH:mm"]).format("HH:mm");
}

/**
 * @param {object|null} detail GET /WA/meeting-schedules/:id (biasanya berisi `admin_group.phone_number_id`)
 * @param {object|null} listRow baris list / merged record — digabung { ...listRow, ...detail }
 */
export function resolveSchedulePhoneNumberId(detail, listRow = null) {
  const merged = { ...(listRow || {}), ...(detail || {}) };
  if (!merged || Object.keys(merged).length === 0) return null;
  const raw =
    merged.phone_number_id ??
    merged.admin_group?.phone_number_id ??
    merged.phone_number?.id;
  if (raw === undefined || raw === null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function getScheduleGreeting() {
  const h = dayjs().hour();
  if (h >= 4 && h < 11) return "Pagi";
  if (h >= 11 && h < 15) return "Siang";
  if (h >= 15 && h < 18) return "Sore";
  return "Malam";
}

export function resolveTemplateVarValue(content, { scheduleDetail, timeSource }) {
  switch (content) {
    case "customer_name":
      return scheduleDetail?.contact?.name ?? "";
    case "start_time":
      return formatScheduleSlotTime(timeSource?.start_time ?? scheduleDetail?.start_time);
    case "end_time":
      return formatScheduleSlotTime(timeSource?.end_time ?? scheduleDetail?.end_time);
    case "date": {
      const d = timeSource?.date ?? scheduleDetail?.date;
      return d ? dayjs(d).format("dddd, D MMMM") : "";
    }
    case "company_name":
      return scheduleDetail?.contact?.company ?? "";
    case "agent_name":
      return scheduleDetail?.schedule_admin_name ?? "";
    case "greeting":
      return getScheduleGreeting();
    case "custom1": {
      const st = formatScheduleSlotTime(timeSource?.start_time ?? scheduleDetail?.start_time);
      return `Kami ingin meminta konfirmasi terkait Visit yang akan dilaksanakan pada hari ini pukul ${st} WIB. Apakah bisa dikonfirmasi kesediaan hadirnya, Kak? Terima kasih`;
    }
    case "empty":
    default:
      return "";
  }
}

export function resolveScheduleContactId(detail) {
  if (!detail) return null;
  const raw = detail.contact_id ?? detail.contact?.id;
  if (raw === undefined || raw === null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}

export function resolveScheduleAdminGroupId(detail) {
  if (!detail) return null;
  const raw = detail.admin_group_id ?? detail.admin_group?.id;
  if (raw === undefined || raw === null || raw === "") return null;
  const n = Number(raw);
  return Number.isFinite(n) ? n : null;
}
